import { WidthLimiter } from '../UI/WidthLimiter/WidthLimiter';
import './Footer.scss';
import logo from "../../assets/image/LogoWhite.svg"

const Footer = () => {
  return (
      <WidthLimiter>
        <div className="footer" id="footer">
          <div className="footer__top">
            <img src={logo} alt="LogoWhite"/>
            <ul className="footer__col">
              <li><span className="white-text">Контакты</span></li>
              <li><span className="white-text">Email: </span><span>Info@mpo.kg</span></li>
              <li><span className="white-text">Адрес: </span><span>720017, г. Бишкек, ул. Исанова 42/2, 405</span>
              </li>
            </ul>
          </div>
          <div className="footer__divider"></div>
          <div className="footer__bottom">© 2024, MPO.KG</div>
        </div>
      </WidthLimiter>
  );
};

export default Footer;
